import React, { useEffect } from 'react';
import styles from './modal-window.module.scss';
import ReactDOM from 'react-dom';

interface IModalWindowProps {
  onClickOutside?: (value: boolean) => void;
  children: React.ReactNode;
}

export const ModalWindow: React.FC<IModalWindowProps> = ({
  onClickOutside,
  children,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return ReactDOM.createPortal(
    <div
      className={styles.modal__container}
      onClick={(e) => {
        if (e.target === e.currentTarget && onClickOutside) {
          onClickOutside(false);
        }
      }}
    >
      {children}
    </div>,
    document.body // Рендер вне React-дерева
  );
};
